import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetMembershipDetails, GetMembershipDetailsResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';
import { immerable } from 'immer';

const getData = (response?: SWRResponse<GetMembershipDetailsResponse, GetMembershipDetailsResponse>) => response?.data;

const getError = (response?: SWRResponse<GetMembershipDetailsResponse, GetMembershipDetailsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetMembershipDetailsResponse, GetMembershipDetailsResponse>) => ({
    [immerable]: true,
    Title: response?.data?.title,
    FirstName: response?.data?.firstName,
    LastName: response?.data?.lastName,
    Address: response?.data?.address,
    Suburb: response?.data?.suburb,
    Postcode: response?.data?.postcode,
    State: response?.data?.state,
    Country: response?.data?.country,
    Phone: response?.data?.phone,
    Email: response?.data?.email,
    Speciality: response?.data?.speciality,
    SpecialitySpec: response?.data?.specialitySpec,
    Institution : response?.data?.institution,
});

export const useMembershipDetails = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) { 
            return undefined;
        }

        return () => {
            return new GetMembershipDetails({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useMembershipDetails;

